import { useRef } from "react";
import { TextField } from "@mui/material";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { message } from "../../../Redux/redux";

const AskUs = () => {
  const consentCheckboxRef = useRef(null);
  // const history = useHistory();
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(message());
  };
  const navigate = useNavigate();
  const onSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    formData.append("consent", consentCheckboxRef.current.checked);
    console.log("askus", Object.fromEntries(formData.entries()));
    navigate("/");
    formData.append("access_key", "b3e05231-a97f-4182-8c24-be343a2b0119");
    const object = Object.fromEntries(formData);
    const json = JSON.stringify(object);
    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: json,
    }).then((res) => res.json());

    if (res.success) {
      console.log("Success", res);
    }
  };

  return (
    <>
      <div className="container askus my-4">
        <h1 className="product-title">Send us your question(s)</h1>
        <form onSubmit={onSubmit}>
          <Row>
            <Col xs={12} md={6} lg={6} className="twofields">
              <TextField
                id="first-name"
                name="firstName"
                label="First Name"
                variant="outlined"
                fullWidth
                className="custom-textfield"
                InputLabelProps={{ shrink: true }}
                autoFocus
              />
            </Col>
            <Col xs={12} md={6} lg={6} className="twofields">
              <TextField
                id="last-name"
                name="lastName"
                label="Last Name"
                variant="outlined"
                fullWidth
                className="custom-textfield"
                InputLabelProps={{ shrink: true }}
              />
            </Col>
            <Col xs={12} md={6} lg={6} className="twofields">
              <TextField
                id="company-name"
                name="companyName"
                label="Company Name"
                variant="outlined"
                fullWidth
                className="custom-textfield"
                InputLabelProps={{ shrink: true }}
              />
            </Col>
            <Col xs={12} md={6} lg={6} className="twofields">
              <TextField
                id="job-title"
                name="jobTitle"
                label="Job Title"
                variant="outlined"
                fullWidth
                className="custom-textfield"
                InputLabelProps={{ shrink: true }}
              />
            </Col>
            <Col xs={12} md={6} lg={6} className="twofields">
              <TextField
                id="corporate-email"
                name="corporateEmail"
                label="Corporate Email"
                variant="outlined"
                fullWidth
                className="custom-textfield"
                InputLabelProps={{ shrink: true }}
              />
            </Col>
            <Col xs={12} md={6} lg={6} className="twofields">
              <TextField
                id="phone-number"
                name="phoneNumber"
                label="Phone Number"
                variant="outlined"
                fullWidth
                className="custom-textfield"
                InputLabelProps={{ shrink: true }}
              />
            </Col>
            <Col xs={12} md={6} lg={6} className="twofields">
              <TextField
                id="country"
                name="country"
                label="Country"
                variant="outlined"
                fullWidth
                className="custom-textfield"
                InputLabelProps={{ shrink: true }}
              />
            </Col>
            <Col xs={12} md={6} lg={6} className="twofields">
              <TextField
                id="hear-about-us"
                name="hearAboutUs"
                label="How Did You Hear About Us?"
                variant="outlined"
                fullWidth
                className="custom-textfield"
                InputLabelProps={{ shrink: true }}
              />
            </Col>
            <Col xs={12} md={12} lg={12} className="twofields">
              <TextField
                id="share-details"
                name="shareDetails"
                label="Share Details"
                multiline
                rows={4}
                variant="outlined"
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Col>
            <Col xs={12} md={12} lg={12} className="twofields">
              <TextField
                id="help-details"
                name="helpDetails"
                label="How Can We Help?"
                multiline
                rows={4}
                variant="outlined"
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Col>
            <Col xs={12} md={12} lg={12} className="twofields">
              <p>
                By checking the box below, you consent to receiving thought
                capital – such as white papers, webinars, news and research –
                and other communications from VENSAP. When you download an
                asset, VENSAP representatives may contact you to provide
                additional information or answer questions.
              </p>
              <p>
                VENSAP will never sell or share your information with anyone.
                You may opt-out at any time. Please refer to the VENSAP privacy
                statement to understand how we manage and protect your personal
                information.
              </p>
            </Col>
            <Col xs={12} md={12} lg={12} className="d-flex align-item-center">
              <input
                type="checkbox"
                id="askuscheck"
                name="askuscheck"
                ref={consentCheckboxRef}
                className="me-4"
              />
              <span> I consent to receive communications from VENSAP</span>
            </Col>
            <Col xs={12} md={12} lg={12} className="twofields my-4">
              <button type="submit"  onClick={handleClick} className="main-btn">
                Submit
              </button>
            </Col>
          </Row>
        </form>
      </div>
    </>
  );
};

export default AskUs;
